export default __webpack_public_path__ + "static/media/stylifyLogoRed.a0804cb7.png";